import React from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportAccessibility from './reportAccessibility';

import 'firebase/compat/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);
const root = createRoot(document.getElementById('root') as HTMLElement);

// eslint-disable-next-line react/react-in-jsx-scope
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Exclude quillforms internals from axe scans — violations there (role="presentation"
// on <button>, etc.) are known library bugs that cannot be fixed from userland.
reportAccessibility(React, undefined, {
  exclude: [
    '.renderer-core-form-flow__wrapper',
    // WDS / CRA compile overlay — dev-only, not an app accessibility issue
    '#webpack-dev-server-client-overlay',
  ],
});
